import { createEditor } from 'slate';
import { withReact } from 'slate-react';
import { withHistory } from 'slate-history';

import { NODE_TYPES } from './doc-editor';

export const getDocLastUpdate = (docMembers = [], author, createdAt) => docMembers
    .reduce((lastUpdate, { last_edited: date, id: userId }) => date && (new Date(date).getTime() > lastUpdate.date) ? {
        userId,
        date: new Date(date).getTime()
    } : lastUpdate, {
        userId: author,
        date: new Date(createdAt || 0).getTime()
    });

export const getDocLastSeenByUser = (docMembers = [], userId) => {
    if (!userId) {
        return null;
    }

    const member = docMembers.find(user => user.id === userId);

    if (!member || !member.last_seen) {
        return null;
    }

    return new Date(member.last_seen).getTime();
}

export const getDocPermission = (docMembers = [], userId) => {
    const member = docMembers.find(user => user.id === userId);

    if (!member) {
        return 'view';
    }

    return member.permission;
}

export const niftyDoc = () => {
    const editor = withHistory(withReact(createEditor()));
    const { isInline } = editor;

    editor.isInline = element => {
        return [NODE_TYPES.comment].includes(element.type) ? true : isInline(element);
    }

    return editor;
}
